// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import ChatContextInput from "entity/ChatContextInput";
import ChatInput from "entity/ChatInput";
import ChatOutput from "entity/ChatOutput";
import ChatStateUpdate from "entity/ChatStateUpdate";
import ChatbotTranscripts, { processChatbotTranscripts } from "entity/ChatbotTranscripts";

import { RestController, RestRequest } from "./RestController";

export default class ChatbotController extends RestController {

    /*
     Get all chat transcripts
     */

    getAllChatTranscripts(): Promise<ChatbotTranscripts> {
        const request = new RestRequest("/api/v1/chatbot/transcripts", "GET", null, undefined);
        return this.request(request, processChatbotTranscripts) as Promise<ChatbotTranscripts>;
    }

    /*
     Called once per session to register context.
     */

    initializeSession(input: ChatContextInput): Promise<void> {
        const request = new RestRequest("/api/v1/chatbot/session/init", "POST", input, undefined);
        return this.requestVoid(request);
    }

    /*
     Sends a user message during an active chat and returns a reply.
     */

    sendMessage(input: ChatInput): Promise<ChatOutput> {
        const request = new RestRequest("/api/v1/chatbot/message", "POST", input, undefined);
        return this.request(request, null) as Promise<ChatOutput>;
    }

    /*
     Updates live session state (mic/video/group/etc).
     */

    updateState(input: ChatStateUpdate): Promise<void> {
        const request = new RestRequest("/api/v1/chatbot/state/update", "POST", input, undefined);
        return this.requestVoid(request);
    }

}
